var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';

var MarginCellRenderer =
/** @class */
function (_super) {
  __extends(MarginCellRenderer, _super);

  function MarginCellRenderer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MarginCellRenderer.prototype.render = function () {
    var value = this.props.value;
    var displayValue = value;

    if (value === null || value === undefined) {
      displayValue = '-';
    } else if (typeof value === 'object') {
      var productPrice = value.productPrice;
      var displayPrice = '-';

      if (productPrice && productPrice.displayPrice) {
        var price = productPrice.displayPrice;
        price = typeof price === 'string' ? parseFloat(price) : price;
        displayPrice = price + "%";
      }

      var priceCell = React.createElement("div", {
        className: "price-cell"
      }, React.createElement("span", null, displayPrice));
      return priceCell;
    }

    return React.createElement("span", null, displayValue);
  };

  return MarginCellRenderer;
}(Component);

export default MarginCellRenderer;